import React from 'react';
import { Link } from 'react-router-dom';
import HamburgerMenu from './HamburgerMenu';

const PartsPage = ({ theme, toggleTheme }) => {
    const isDark = theme === 'dark';
    const styles = {
        bg: isDark ? '#121212' : '#f4f7f6',
        card: isDark ? '#1e1e1e' : '#fff',
        text: isDark ? '#e0e0e0' : '#333',
        border: isDark ? '#444' : '#ddd',
        grid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginTop: '20px' },
        actionCard: { display: 'flex', flexDirection: 'column', padding: '20px', backgroundColor: isDark ? '#1e1e1e' : '#fff', border: `1px solid ${isDark ? '#444' : '#ddd'}`, borderRadius: '8px', textDecoration: 'none', color: isDark ? '#e0e0e0' : '#333', transition: 'transform 0.2s' },
        icon: { fontSize: '40px', marginBottom: '10px' }
    };

    return (
        <div style={{ backgroundColor: styles.bg, minHeight: '100vh', padding: '20px', color: styles.text, fontFamily: 'sans-serif' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', gap: '15px', flexWrap: 'wrap' }}>
                    <HamburgerMenu theme={theme} />
                    <h1 style={{ margin: 0 }}>Parts Management</h1>

                    {/* Light/Dark Mode Toggle Button */}
                    <button
                        onClick={toggleTheme}
                        style={{
                            marginLeft: 'auto',
                            padding: '8px 16px',
                            borderRadius: '20px',
                            border: `1px solid ${styles.border}`,
                            backgroundColor: styles.card,
                            color: styles.text,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: 'bold',
                            fontSize: '14px'
                        }}
                    >
                        {isDark ? '☀️ Light Mode' : '🌙 Dark Mode'}
                    </button>
                </div>

                <div style={styles.grid}>
                    <Link to="/parts-on-hand" style={styles.actionCard}>
                        <div style={styles.icon}>🔩🗄️</div>
                        <h3>Parts on Hand</h3>
                        <p>Tracked Parts on Hand For All Sites</p>
                    </Link>

                    {/* Add more links here later! */}
                    {/* <Link to="/tracked-parts" style={styles.actionCard}>...</Link> */}
                </div>
            </div>
        </div>
    );
};

export default PartsPage;